import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from '../services/cache.service';
import { ConstantsService } from '../services/constants.service';
import { GetPaymentService } from '../services/get-payment.service';
import { SpinnerService } from '../services/spinner.service';
// import { HelperService } from '../services/helper.service';
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit, OnDestroy {
  public userName = "";
  public showPendingList = true;
  public showApprovedList = false;
  public showRejectList = false;
  public showUploadedList = false;
  public showGdriveList = false;
  public showFailedList = false;
  public showCuratedList = false;
  public currentAuthUser = '';
  public currentAuthUserEmail = '';
  public isAdmin: any;
  public profilePicture;
  public from = this.constants.ADMIN_TXT;
  constructor(
    private router: Router,
    public constants: ConstantsService,
    private authenticate: CacheService,
    private get_payment: GetPaymentService,
    private spinner: SpinnerService
    // private helperService:HelperService
  ) { }
  async authUser() {
    this.authenticate.getAuthUser()
      .then(async data => {
        let { userName, picture, login, given_name } = data
        this.profilePicture = picture
        this.userName = userName
        await this.get_payment.getUserData(userName, given_name)
        if (!login) {
          this.router.navigate(['/login'])
        }
        this.spinner.hide()
      })
    this.spinner.hide()
  }
  ngOnInit(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.addGlobalStyle('.publift-widget-23174194645-container,.publift-widget-23196941527-container { display: none !important}');
    this.authUser();
    this.showPendingList = false;
    this.showApprovedList = false;
    this.showRejectList = false;
    this.showUploadedList = false;
    this.showGdriveList = false;
    let currentUrl = document.URL.split("/")
    this.from = currentUrl.slice(3).toLocaleString().toLowerCase();
    if (this.from === this.constants.ADMIN_TXT) {
      this.showPendingList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.APPROVED_TXT}`) {
      this.showApprovedList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.REJECTED_TXT}`) {
      this.showRejectList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.UPLOADED_TXT}`) {
      this.showUploadedList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.UPLOADED_TXT},1`) {
      this.showUploadedList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.GDRIVE_TXT}`) {
      this.showGdriveList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.FAILED_TXT}`) {
      this.showFailedList = true;
    }
    if (this.from === `${this.constants.ADMIN_TXT},${this.constants.CURATED_TXT}`) {
      this.showCuratedList = true;
    }
    
  }

  ngOnDestroy(): void {
    // The section below is commented out because Publift ads need to be removed.
    // this.helperService.removeGlobalStyle();
  }
  
}
